/*
 * @Author: Teemo Ding
 * @Date: 2021-12-06 13:24:59
 * @LastEditTime: 2022-01-29 11:03:20
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/ExclusiveCustom/SelectCustomisation.tsx
 */
import React, { Fragment, useEffect } from 'react';
import { Form } from 'antd';
import { Input, ModalFooter, Select } from '@/src/components/Antd';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

const formName = 'selectCustomisation';
const SelectCustomisation = ({
  serviceDetails,
  onCancel,
  onAdd,
  productName,
  sku,
  defaultValue,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const optionsTransition = (options, type) =>
    options.map((item) => ({ label: item.value, value: item.value }));

  const onFinish = (values) => {
    const entriesValues = Object.entries(values);
    const submitData = entriesValues.map((item: any) => {
      const serviceDetailsIndex = serviceDetails.filter(
        (o) => o.uuid == item[0],
      );
      return {
        productServiceDetailUuid: item[0],
        values:
          (serviceDetailsIndex[0] || {}).type == 'Checkbox'
            ? item[1]
            : [item[1]],
      };
    });
    onAdd(submitData);
    onCancel();
  };

  useEffect(() => {
    const formData = {};
    (defaultValue || []).forEach((item) => {
      const serviceDetailsIndex = (serviceDetails || []).find(
        (o) => o.uuid === item.productServiceDetailUuid,
      );

      if (serviceDetailsIndex) {
        if (serviceDetailsIndex.type === 'Checkbox') {
          formData[item.productServiceDetailUuid] = item.values;
        } else {
          formData[item.productServiceDetailUuid] = item.values[0];
        }
      }
    });

    form.setFieldsValue(formData);
  }, []);

  return (
    <Fragment>
      <Form
        form={form}
        className={css.selectCustomisation}
        name={formName}
        onFinish={onFinish}>
        <div className={css.header}>
          <div className={css.headerItem}>
            <div className={css.title}>{getI18n('general.productName')}</div>
            <div className={css.content}> {productName}</div>
          </div>
          <div className={css.headerItem}>
            <div className={css.title}>{getI18n('general.sKU')}</div>
            <div className={css.content}>{sku}</div>
          </div>
        </div>
        {(serviceDetails || []).map((item, index) => (
          <Form.Item
            key={index}
            name={item.uuid}
            label={`${item.title}*`}
            rules={[
              {
                required: true,
                message: replaceI18nVariables(
                  getI18n('general.fieldisrequired'),
                  item.title,
                ),
              },
            ]}
            labelCol={{ span: 24 }}>
            {item.type == 'Text' ? (
              <Input size='large' />
            ) : (
              <Select
                size='large'
                //getPopupContainer={() => document.body}
                mode={item.type == 'Checkbox' ? 'multiple' : null}
                options={optionsTransition(item.options, item.type)}
                value={
                  Array.isArray(form.getFieldValue(item.uuid))
                    ? form.getFieldValue(item.uuid)
                    : []
                }
              />
            )}
          </Form.Item>
        ))}
      </Form>
      <ModalFooter
        onCancel={onCancel}
        onOk={() => form.submit()}
        okText={getI18n('general.confirm')}
      />
    </Fragment>
  );
};

export default SelectCustomisation;
